import React, { useState, useEffect, useRef, useCallback } from "react";
import MinDataService from "../services/MinService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const MinList = (props) => {
  const [min, setMin] = useState([]);
  const minRef = useRef();
  minRef.current = min;

  let { owner } = useParams();

  const retrieveMin = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    MinDataService.getAll(target)
      .then((response) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.min ?? payload;
        setMin(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("MinList.retrieveMin error:", e?.response?.status, e?.response?.data || e?.message || e);
        setMin([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveMin();
  }, [retrieveMin]);

  const deleteMin = useCallback((rowIndex) => {
    const id = minRef.current[rowIndex].id || minRef.current[rowIndex]._id;
    MinDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/min");
        const newRows = [...minRef.current];
        newRows.splice(rowIndex, 1);
        setMin(newRows);
      })
      .catch((e) => {
        console.error("deleteMin error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/min/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/min/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = minRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteMin(idx);
  }, [deleteMin]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={min}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/min/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Min Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default MinList;
